import { BASE_URL } from '../../config/config';

export const userService = {
  getProfileWithBookings: async (userId) => {
    try {
      const url = new URL(`${BASE_URL}/user/profile-with-bookings`);
      url.searchParams.append('userId', userId);

      const response = await fetch(url.toString(), {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Failed to fetch profile data');
      }

      return data;
    } catch (error) {
      throw error;
    }
  },

  updateProfile: async (userId, userData) => {
    try {
      const response = await fetch(`${BASE_URL}/user/update-profile?userId=${userId}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(userData),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Failed to update profile');
      }

      return data;
    } catch (error) {
      throw error;
    }
  }
};
